// Control implemented as ES6 class
import availableIcon from "../assets/icons/available.jpg"
import occupiedIcon from "../assets/icons/occupied.jpg"
import blockedIcon from "../assets/icons/blocked.jpg"
import allIcon from "../assets/icons/reset.png"

const icons = {
  available: availableIcon,
  occupied: occupiedIcon,
  blocked: blockedIcon,
  all: allIcon
}

export class HexagonControl {
  constructor(
    options = {
      available: () => {},
      occupied: () => {},
      blocked: () => {},
      all: () => {}
    }
  ) {
    this._container = this._container = document.createElement("div")
    this._container.className = "mapboxgl-ctrl mapboxgl-ctrl-group"
    ;["all", "available", "occupied", "blocked"].forEach(type => {
      let button = this.createButton("hex-filter", `${type}-hex`, options[type])
      let icon = document.createElement("img")
      icon.src = icons[type]
      icon.width = 20
      icon.height = 20
      //   icon.className = "mapbox-ctrl-icon";
      button.appendChild(icon)
    })
  }

  onAdd(map) {
    this._map = map
    return this._container
  }

  onRemove() {
    this._container.parentNode.removeChild(this._container)
    this._map = undefined
  }

  createButton(className = "", id = "", fn = () => {}) {
    const a = document.createElement("button")
    a.className = className
    this._container.appendChild(a)
    a.type = "button"
    a.addEventListener("click", fn)
    return a
  }
}
